import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Package } from 'lucide-react';

const ServiceTemplate = ({ title, subtitle, description, whatIsIt, whoFor, whenToUse, howWeHelp, benefits, nextSteps, image }) => {
  return (
    <div>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-slate-50" data-testid="service-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-xs font-mono tracking-widest uppercase text-orange-500">{subtitle}</span>
              <h1 
                className="text-5xl md:text-7xl font-bold tracking-tight uppercase mt-4 mb-6"
                style={{fontFamily: 'Barlow Condensed, sans-serif'}}
                data-testid="service-title"
              >
                {title}
              </h1>
              <p className="text-xl leading-relaxed text-slate-600 mb-8">{description}</p>
              <Link
                to="/contact"
                data-testid="service-quote-btn"
                className="bg-slate-900 text-white px-8 py-4 rounded-sm text-base font-medium hover:bg-orange-500 transition-colors duration-300 inline-flex items-center gap-2"
              >
                Request a Quote
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
            <div className="h-96 rounded-sm overflow-hidden">
              <img src={image} alt={title} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 space-y-16">
          {/* What Is It */}
          <div>
            <h2 
              className="text-3xl md:text-5xl font-bold tracking-tight uppercase mb-6"
              style={{fontFamily: 'Barlow Condensed, sans-serif'}}
            >
              What is {title}?
            </h2>
            <p className="text-lg leading-relaxed text-slate-600">{whatIsIt}</p>
          </div>

          {/* Who For */}
          <div>
            <h2 
              className="text-3xl md:text-5xl font-bold tracking-tight uppercase mb-6"
              style={{fontFamily: 'Barlow Condensed, sans-serif'}}
            >
              Who is this for?
            </h2>
            <p className="text-lg leading-relaxed text-slate-600">{whoFor}</p>
          </div>

          {/* When to Use */}
          <div>
            <h2 
              className="text-3xl md:text-5xl font-bold tracking-tight uppercase mb-6"
              style={{fontFamily: 'Barlow Condensed, sans-serif'}}
            >
              When should you use this service?
            </h2>
            <p className="text-lg leading-relaxed text-slate-600">{whenToUse}</p>
          </div>

          {/* How We Help */}
          <div>
            <h2 
              className="text-3xl md:text-5xl font-bold tracking-tight uppercase mb-6"
              style={{fontFamily: 'Barlow Condensed, sans-serif'}}
            >
              How NETEXEC Helps
            </h2>
            <p className="text-lg leading-relaxed text-slate-600 mb-6">{howWeHelp}</p>
            <div className="space-y-3">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                  <span className="text-base text-slate-600">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-slate-50 border border-slate-200 p-8 rounded-sm">
            <h3 className="text-xl font-semibold mb-4 text-slate-900">Next Steps</h3>
            <p className="text-base leading-relaxed text-slate-600 mb-6">{nextSteps}</p>
            <Link
              to="/contact"
              className="bg-slate-900 text-white px-8 py-4 rounded-sm text-base font-medium hover:bg-orange-500 transition-colors duration-300 inline-flex items-center gap-2"
            >
              Get Started
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceTemplate;